export enum TreeType {
    Product = "product",
    Service = "service",
    OperatingRegime = "operating regime",
    Applications = "secorts applications",
    Custom = "custom",
}

export interface TreeStructure {
    id: string;
    label: string;
    children?: TreeStructure[];
}
